import AddIcon from '@mui/icons-material/Add';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import NotInterestedOutlinedIcon from '@mui/icons-material/NotInterestedOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, ButtonBase, InputBase, useTheme } from "@mui/material";
import cx from 'classnames';
import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useInView } from 'react-intersection-observer';
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { AMStreamFinished, AMStreamInProrgess, AMStreamPicked } from '../../../components/global/Modals/ActionModal/AMStream';
import MConfirmEndPickingJob from '../../../components/global/Modals/MConfirmEndPickingJob';
import MConfirmation from '../../../components/global/Modals/MConfirmation';
import MCreateBatch from '../../../components/global/Modals/MCreateBatch/MCreateBatch';
import MSelectWorkspaces from "../../../components/global/Modals/MSelectWorkspaces";
import MpCreateStandaloneShipment from "../../../components/global/ModalsProgression/MpCreateStandaloneShipment/MpCreateStandaloneShipment";
import Shbutton from "../../../components/theme/buttons/Shbutton";
import ShDataGrid2 from '../../../components/theme/datagrid2/ShDataGrid2';
import CardLabel from '../../../components/theme/label/CardLabel';
import ShLabel from "../../../components/theme/label/ShLabel";
import SHQuickAction from '../../../components/theme/Modal/SHQuickAction';
import TopRight from '../../../components/theme/positionals/TopRight';
import SelectGroup from "../../../components/theme/Select/SelectGroup";
import SidepanelLoader from '../../../components/theme/sidepanel2/SidepanelLoader';
import ShTextSkeleton from '../../../components/theme/skeleton/ShTextSkeleton';
import Subheading from "../../../components/theme/text/Subheading";
import Text from "../../../components/theme/text/Text";
import { GridFilterProvider } from '../../../contexts/GridFilterContext';
import { TabContextProvider } from '../../../contexts/TabContext';
import { useTopbar } from "../../../contexts/TopbarProvider";
import { useGetInvoiceProductsSelectQuery } from "../../../newapi/financial/invoiceProductSlice";
import { useFindPickingJobMutation, useFindPickingJobsQuery, useStartFindOrdersMutationMutation } from "../../../newapi/global/echeckSlice";
import { useGetSettingsQuery } from "../../../newapi/global/generalApiSlice";
import { setWorkSpace, updateMenuState } from '../../../newapi/global/settingsSlice';
import { useGetPausedOrdersForProcessingQuery } from '../../../newapi/order/ordersSlice';
import { useFindAllConceptJobsQuery, useFinishPickingJobMutation } from '../../../newapi/pickingjob/pickingjobSlice';
import { selectUserPermission } from '../../../newapi/user/authentication/authSlice';
import { useFindWorkspacesSelectQuery } from "../../../newapi/warehouse/workspaceSlice";
import { ReactComponent as BarcodeSvg } from "../../../styles/svg/barcode.svg";
import { tokens } from "../../../theme";
import { getPickingJobStateData } from "../../../utils/labelColorText";
import { UserPrivileges } from '../../../utils/permissions';
import { autoFinalizeValues, general_states } from "../../../utils/staticEnums";
import IndividualOrderEcheckView from "./individualorder/IndividualOrderEcheckView";
import LocationsEcheckView from "./locations/LocationsEcheckView";
import OrdersEcheckView2 from './orders/OrdersEcheckView2';
import EcheckContentWrapper from "./components/EcheckContentWrapper";
import { MEditBatch } from '../../../components/global/Modals/MCreateBatch/MEditBatch';

import errorSound from '../../../styles/sounds/error.mp3';
import successSound from '../../../styles/sounds/success.mp3';
import { addAction } from '../../../newapi/global/actionProgressSlice';
import { buildEcheckPerfTestJob } from './helper';

const SpPickingJobPickingList = SidepanelLoader(() => import("../../../components/global/Sidepanels/SpPickingJobPickingList/SpPickingJobPickingList"));

const ECHECK_STATE_VISIBILITY_KEY = "echeck_state_visibility";


const Echeck = () => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode); 
    const dispatch = useDispatch();
    const [showEcheck, setShowEcheck] = useState(false);
    const [showPausedOrdersForProcessing, setShowPausedOrdersForProcessing] = useState(false);
    const [scannedValue, setScannedValue] = useState('none');
    const [highlightColor, setHighlightColor] = useState('none');
    const [incData, setIncData] = useState();
    const inputRef = useRef(null);


    const successAudioRef = useRef();
    const errorAudioRef = useRef();
    if (!successAudioRef.current) successAudioRef.current = new Audio(successSound);
    if (!errorAudioRef.current) errorAudioRef.current = new Audio(errorSound);


    const [isExtended,setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const { showExtraComponent, clearExtraComponent,showExtraTitle,clearExtraTitle } = useTopbar();

    const hasBulkPermission = useSelector((state) => 
        selectUserPermission(state,[UserPrivileges.PICKINGJOB_BULK_ACTION])
    );
    const {data:invoiceProductsEcheck,isLoading:invoiceProductsLoading} = useGetInvoiceProductsSelectQuery(general_states.ECHECK);

    const [searchParams] = useSearchParams();
    const finalizOorder = searchParams.get('finalizeorder');

    const [stateVisibility, setStateVisibility] = useState(() => {
        const defaultVisibility = {
            completed: false,
            fullypicked: true,
            in_progress: true,
        };
        // The chosen state filters survive a page refresh
        try {
            const stored = JSON.parse(localStorage.getItem(ECHECK_STATE_VISIBILITY_KEY));
            return { ...defaultVisibility, ...stored };
        } catch {
            return defaultVisibility;
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem(ECHECK_STATE_VISIBILITY_KEY, JSON.stringify(stateVisibility));
        } catch {
            // Storage unavailable (private mode, blocked site data): keep the filters in memory only
        }
    }, [stateVisibility]);

    const { ref, inView } = useInView({
        threshold: 1.0,
    });

    //UNCOMMENT WHEN NEW STATE IS ADDED
    const { data: pausedOrdersForProcessing } = useGetPausedOrdersForProcessingQuery({
        args: {
            page: 1,
            size: 100,
        },
        invalidate: true,
    });

    const [orderToFinalize, setOrderToFinalize] = useState(null);
    useEffect(() => {
        if(finalizOorder !== null) {
            const splitFinalizeOrder = atob(finalizOorder).split("+");
            
            if(!splitFinalizeOrder || splitFinalizeOrder.length !== 2) return;
            setOrderToFinalize({
                id: splitFinalizeOrder[0],
                state:splitFinalizeOrder[1],
            });
        }
    },[finalizOorder])
    

    const resetWorkspace = () => {
        dispatch(setWorkSpace({
            id: -1,
            name: "workspace_not_set"
        }))
    }

    const [open, setOpen] = useState(false);
    const workSpaceModal = {
        open: open,
        setOpen: setOpen
    }

    const [createShipmentOpen, setCreateShipmentOpen] = useState(false);
    const createShipmentModal = {
        open: createShipmentOpen,
        setOpen: setCreateShipmentOpen
    }

    // Single B2B-order warning modal, shared by all three echeck views. The views
    // detect the B2B order (they hold currentOrder) and signal up via onB2bOrderOpened;
    // rendering it here keeps it from duplicating across each view's mounts.
    const [b2bWarningOpen, setB2bWarningOpen] = useState(false);

    // findorder
    // Use mutation instead of query
    const [startFindOrders, { data: startFindOrdersData, isLoading,isFetching, isError }] = useStartFindOrdersMutationMutation();
    const { data: eCheckSettings} = useGetSettingsQuery("echeck");


    const hasClickToScanPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.SENDING_CLICK_TO_SCAN])
    );

    const hasAllowedToSetCustomCarrierShipperPermission = useSelector((state) => 
        selectUserPermission(state,[UserPrivileges.ALLOW_SET_CUSTOM_CARRIER_SHIPPER])
    );

    const firstProductClick = eCheckSettings?.find(setting => setting.key === 'echeck_confirm_for_product_row_click')?.value === "true";

    const playSound = eCheckSettings?.find(setting => setting.key === 'echeck_sound_when_scanning')?.value === "true";
    const playSoundOnlyForWrongScan = eCheckSettings?.find(setting => setting.key === 'echeck_sound_when_wrong_scan')?.value === "true";

    const displayPopupForOutboundInstructions = eCheckSettings?.find(setting => setting.key === 'echeck_popup_for_outbound_instructions')?.value === "true";

    const displayPopupForB2bOrder = eCheckSettings?.find(setting => setting.key === 'echeck_popup_for_b2b_order')?.value === "true";

    const openSinglesModalOnScan = eCheckSettings?.find(setting => setting.key === 'echeck_open_singles_modal_on_scan')?.value === "true";

    const confirmProductAmountSetting = eCheckSettings?.find(setting => setting.key === 'echeck_confirm_product_amount')?.value === "true";
    const canSkipAmountCheck = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.ECHECK_SKIP_AMOUNT_CHECK])
    );
    // Admins and users with the skip privilege never get the product amount check.
    // The views decide per order (product, relation, then this general setting) and render the confirmation modal.

    const carrierMandatory = eCheckSettings?.find(setting => setting.key === 'echeck_carrier_mandatory')?.value === "true";
    // Finalize an order without printing its label; the labels are printed later from the orders
    const hasFinalizeWithoutLabelPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.ECHECK_FINALIZE_WITHOUT_LABEL])
    );
    const canFinalizeWithoutLabel = hasFinalizeWithoutLabelPermission &&
        eCheckSettings?.find(setting => setting.key === 'echeck_finalize_without_label')?.value === "true";
    const viewStocksInOrderProcessing = eCheckSettings?.find(setting => setting.key === 'echeck_view_stocks_in_order_processing')?.value === "true";
    const viewPickingLinesInOrderProcessing = eCheckSettings?.find(setting => setting.key === 'echeck_view_pickinglines_in_order_processing')?.value === "true";
    const clickAllProducts = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.ECHECK_CLICK_ALL_PRODUCTS])
    );

    const canCreateStandAloneShipment = eCheckSettings?.find(setting => setting.key === 'echeck_can_create_standalone_shipment')?.value === "true";

    const autoFinalizeValue = eCheckSettings?.find(setting => setting.key === 'echeck_auto_finalize')?.value;
    const autoFinalize = autoFinalizeValue === autoFinalizeValues.AUTO || autoFinalizeValue === autoFinalizeValues.AUTO_ON_TIMER;
    const finalizeAutoOnTimer = autoFinalizeValue === autoFinalizeValues.AUTO_ON_TIMER;
    const finalizeTimer = eCheckSettings?.find(setting => setting.key === 'echeck_timer_amount')?.value * 1000;
    // Enter only finalizes when nothing finalizes on its own, so an auto finalize setting wins.
    const finalizeOnEnter = !autoFinalize && eCheckSettings?.find(setting => setting.key === 'echeck_finalize_on_enter')?.value === "true";
    const selectedWorkSpace = useSelector((state) => state.settings.workSpace);

    const [page,setPage] = useState(1);
    const [displayCount, setDisplayCount] = useState(25);
    const [completedJobs, setCompletedJobs] = useState([]);

    const playSuccess = () => {
        if(!playSound) return;
        successAudioRef.current.currentTime = 0;
        successAudioRef.current.play().catch(() => {});
    };
    const playError = () => {
        // console.log(!playSound && !playSoundOnlyForWrongScan)
        if(!playSound && !playSoundOnlyForWrongScan) return;
        errorAudioRef.current.currentTime = 0;
        errorAudioRef.current.play().catch(() => {});
    };

    const {data: jobsData, isLoading: jobsLoading, isFetching:jobsFetching,refetch: refetchJobs} = useFindPickingJobsQuery({
        workspaceId: selectedWorkSpace.id,
        completed: stateVisibility.completed,
        page:page,
    },{skip: !selectedWorkSpace || showEcheck, pollingInterval:60000});

    useEffect(() => {
        if (inView) {

        }
    }, [inView]);

    const [getMyJob, {data: individualJob, isLoading: invididualJobLoading}] = useFindPickingJobMutation();

    const stateOrder = ['completed', 'fullypicked', 'in_progress'];  // Define the desired order of states

    // Grouping based on state
    const groupedData = useMemo(() => {
        if(!stateVisibility.completed){
            return jobsData?.pickingJobs.reduce((acc, item) => {
                // Check if the state group exists, if not, create an empty array for that state
                if (!acc.groups[item.state]) {
                    acc.groups[item.state] = [];
                }

                // Push the item to the appropriate state group
                acc.groups[item.state].push(item);

                // If the state is not already in the secondary array, push it
                if (!acc.states.includes(item.state)) {
                    acc.states.push(item.state);
                }

                return acc;
            }, { groups: {}, states: [] });
        } else {
            return null;
        }
    }, [jobsData]);


    useEffect(() => {
        if (stateVisibility.completed && jobsData?.data) {
            setCompletedJobs(prev => {
                const existingIds = new Set(prev.map(j => j.id));
                const newOnes = jobsData.data.filter(j => !existingIds.has(j.id));
                return [...prev, ...newOnes];
            });
        }
    }, [jobsData, stateVisibility.completed]);

    useEffect(() => {
        if (inView && stateVisibility.completed && !jobsFetching) {
            setPage(prev => prev + 1);
        }
    }, [inView, stateVisibility.completed, jobsFetching]);

    // Sort states based on the predefined order (you can modify it according to your needs)
    const sortedStates = groupedData?.states.sort((a, b) => {
        return stateOrder.indexOf(a) - stateOrder.indexOf(b);
    });


    useEffect(() => {
        // Example: show different components based on user privileges
        if(selectedWorkSpace !== null && selectedWorkSpace.id > -1){
            showExtraComponent(
                <Box
                    className={cx('',{
                        'not-selected': selectedWorkSpace === null,
                        // 'not-selected': p,
                    })}
                    sx={{
                        height:40,
                        background:theme.palette.mode === "dark" ? colors.blue[800] : colors.primary[400],
                        borderRadius:5,
                        color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["white"],
                        fontSize:14,
                        fontWeight:"bold",
                        fontFamily:"Roboto, sans-serif",
                        lineHeight:"40px",
                        px:2,
                        "&.not-selected" : {
                            background:colors.red[400],
                            animation: 'pulse 1.5s infinite',
                            '@keyframes pulse': {
                            '0%': {
                                transform: 'scale(1)',
                            },
                            '50%': {
                                transform: 'scale(1.2)',
                            },
                            '100%': {
                                transform: 'scale(1)',
                            },
                            },
                        },
                        "@media screen and (max-width: 47.9375em)" : {
                            display:"none",
                        }
                    }}
                >
                    {selectedWorkSpace !== null ? selectedWorkSpace.name : t("no_selection")}
                </Box>
            );
        }
  
        return () => {
            clearExtraComponent();
        };
    }, [selectedWorkSpace]);

    useEffect(() => {
        showExtraTitle(t("echeck"))

        return () => {
            clearExtraTitle();
        };
    }, [showExtraTitle,clearExtraTitle,t,i18n.language])
    
    useEffect(() => {
        if(window.innerWidth > 1369){
            dispatch(updateMenuState(true));
        }
    },[])
    
    const handleGetPickingJobOrOrderToEcheck = async (e) => {
        if (e.key === 'Enter') {
            // Scanning PERFTEST<count> opens the job overview on a generated payload of
            // that many products, to measure how it renders at scale. Local development
            // only: a production build is not development, and test builds (which run as
            // development under starttest) are marked by REACT_APP_STOCKHUB_ENV.
            const isLocalDevelopment = process.env.NODE_ENV === "development" && !process.env.REACT_APP_STOCKHUB_ENV;
            const perfProductCount = parseInt(e.target.value.match(/^PERFTEST(\d+)$/i)?.[1]);
            if (isLocalDevelopment && perfProductCount > 0) {
                setIncData(buildEcheckPerfTestJob(perfProductCount));
                setScannedValue("");
                setShowEcheck(true);
                e.target.value = "";
                return;
            }

            startFindOrders(e.target.value, selectedWorkSpace.id)
            .unwrap()
            .then(result => {
                // Check if result is for an individual order (container scan)
                if (result.viewType === "individualOrder" && result.order) {
                    // Forward to IndividualOrderEcheckView with pre-fetched data
                    setIncData(result);
                    setOrderToFinalize({
                        id: result.order.id,
                        state: result.order.state,
                    });
                } else {
                    // Forward to regular echeck views (OrdersEcheckView2 or LocationsEcheckView)
                    setIncData(result);
                    setScannedValue(e.target.value);
                    setShowEcheck(true);
                }
            })
            .catch(error => {
                setHighlightColor('red');
                toast.error(error.data?.message ??  `Scan een geldige krat of pickbon`, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            });
        }
    }

    const getPickingJob = async (id) => {
       await getMyJob({
            id: id,
            workspaceId: selectedWorkSpace.id,
        }).unwrap()
        .then(result => {
            // setStateVisibility({
            //     completed: false, // Initially echeck is hidden
            //     fullypicked: true, // Show completed by default
            //     in_progress: true, // Show in_progress by default
            // });

            // console.log(result);
            setIncData(result);
            setScannedValue("");
            setShowEcheck(true);
        })
        .catch(error => {
            setHighlightColor('red');
            toast.error(error.data?.message ??  `Scan een geldige krat of pickbon`, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        });
    }

    useEffect(() => {
        if (highlightColor !== 'none') {
            setTimeout(() => setHighlightColor('none'), 500); // Duration to stay colored
        }
    }, [highlightColor]);

    useEffect(() => {
        if(!showEcheck) {
            refetchJobs();
        }
    },[showEcheck])


    const goBack = () => {
        setScannedValue(null);
        setShowEcheck(false);
    }

    const getBackgroundColor = () => {
        switch (highlightColor) {
            case 'orange':
                return colors.orange[400];
            case 'green':
                return colors.green[400];
            case 'red':
                return colors.red[400];
            default:
                return 'initial'; // or your default color
        }
    };

    const [item,setItem] = useState(null);
    
    const [amStreamInProgressAnchorEl, setAmStreamInProgressAnchorEl] = useState(null);
    const amStreamInProgressPopoverOpen = Boolean(amStreamInProgressAnchorEl);
    const amStreamInProgressPopoverId = amStreamInProgressPopoverOpen ? 'simple-popover' : undefined;


    const handleAmStreamInProgressPopoverClick = (event) => {
        setAmStreamInProgressAnchorEl(event.currentTarget);
    };

    const handleAmStreamInProgressPopoverClose = () => {
        setAmStreamInProgressAnchorEl(null);
        // setExportAnchorEl(null);
    };

    const [amStreamPickedAnchorEl, setAmStreamPickedAnchorEl] = useState(null);
    const amStreamPickedPopoverOpen = Boolean(amStreamPickedAnchorEl);
    const amStreamPickedPopoverId = amStreamPickedPopoverOpen ? 'simple-popover' : undefined;


    const handleAmStreamPickedPopoverClick = (event) => {
        setAmStreamPickedAnchorEl(event.currentTarget);
    };

    const handleAmStreamPickedPopoverClose = () => {
        setAmStreamPickedAnchorEl(null);
        // setExportAnchorEl(null);
    };


    const [amStreamFinishedAnchorEl, setAmStreamFinishedAnchorEl] = useState(null);
    const amStreamFinishedPopoverOpen = Boolean(amStreamFinishedAnchorEl);
    const amStreamFinishedPopoverId = amStreamFinishedPopoverOpen ? 'simple-popover' : undefined;


    const handleAmStreamFinishedPopoverClick = (event) => {
        setAmStreamFinishedAnchorEl(event.currentTarget);
    };

    const handleAmStreamFinishedPopoverClose = () => {
        setAmStreamFinishedAnchorEl(null);
        // setExportAnchorEl(null);
    };

    const [spOrderSidePanelTab,setSpOrderSidePanelTab] = useState(null);
    const activateStreamPanel = (tab) => {
        setSpLoading(true);
        setIsExtended(true);
        setSpOrderSidePanelTab(tab);
    }


    const [createExtendedBatchModalOpen, setCreateExtendedBatchModalOpen] = useState(false);
    const createExtendedBatchModal = {
        open: createExtendedBatchModalOpen,
        setOpen: setCreateExtendedBatchModalOpen
    }

    const handleCreateExtendedBatchOpen = () => {
        setCreateExtendedBatchModalOpen(true);
    }

    const handleCreateExtendedBatchClose = () => {
        setCreateExtendedBatchModalOpen(false);
    };

    return (
        <Box 
            height={1} 
            display={"flex"} 
            width={1} 
            gap={4} 
            paddingX={4} 
            paddingTop={13} 
            overflow={"auto"}
            sx={{
                // overflow:"hidden",
                "@media screen and (max-width: 47.9375em)" : {
                    px:0,
                    pt:9,
                },
                background: getBackgroundColor(), // You can use your original color instead of 'initial' if needed
                transition: 'background-color 0.5s'
            }}
        >
            {/* List content body */}
            {!showEcheck && orderToFinalize === null &&
                <Box
                    sx={{
                        flex:1,
                        display:"flex",
                        gap:4,
                        "@media screen and (max-width: 47.9375em)" : {
                            flexDirection:'column',
                            overflowX:"hidden",
                        }
                    }}
                >
                    <Box
                        sx={{
                            minWidth:355,
                            maxWidth:385,
                            overflow:"auto",
                            "@media screen and (max-width: 47.9375em)" : {
                                minWidth:"unset",
                                width:1,
                                maxWidth:"unset",
                                pb:selectedWorkSpace.id !== -1 ? 9: 0,
                            }
                        }}
                    >
                        <Box
                            sx={{
                                display:"flex",
                                justifyContent:"space-between",
                                alignItems:'center',
                                pb:1,
                                "@media screen and (max-width: 47.9375em)" : {
                                    px:3,
                                    display:selectedWorkSpace.id !== -1 ? "flex": "none",
                                    gap:1.5,
                                    pt:3,
                                },
                            }}
                        >
                            <Subheading>{t("to_process")}</Subheading>

                            {selectedWorkSpace.id !== -1 &&
                                <Box
                                    sx={{
                                        display:"flex",
                                        alignItems:"center",
                                        gap:2,
                                    }}
                                >
                                    <ButtonBase
                                        onClick={() => {workSpaceModal.setOpen(true)}}
                                        sx={{
                                            height:32,
                                            px:2,
                                            borderRadius:4,
                                            border:`1px solid ${colors.grey[100]}`,
                                            boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                            color: colors.txt["primary"],
                                            fontWeight:500,
                                            fontSize:14,
                                            fontFamily:"Roboto, sans-serif",
                                            whiteSpace:"nowrap"
                                        }}
                                    >
                                        {selectedWorkSpace.name}

                                    </ButtonBase>

                                    <ButtonBase
                                        disabled={jobsLoading}
                                        // onClick={resetWorkspace}
                                        onClick={refetchJobs}
                                        sx={{
                                            height:32,
                                            width:32,
                                            borderRadius:4,
                                            background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[400],
                                            color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["white"],
                                            display:"flex",
                                            alignItems:"center",
                                            justifyContent:"center"
                                        }}
                                    >
                                        <RefreshIcon/>

                                    </ButtonBase>
                                </Box>
                            }
                        </Box>

                        <Box
                            sx={{
                                display:"flex",
                                gap:1.5,
                                mt:2,
                                "@media screen and (max-width: 47.9375em)" : {
                                    px:3,
                                    display:selectedWorkSpace.id !== -1 ? "flex": "none",
                                },
                            }}
                        >
                            {stateOrder.map((state, idx) => (
                                <ShLabel
                                    onClick={() => {
                                        setStateVisibility((prevState) => ({
                                          ...prevState,
                                          [state]: !prevState[state],  // Toggle the visibility of the clicked state
                                        }));
                                    }}
                                    variant={stateVisibility[state] ? getPickingJobStateData(state,theme).labelcolor : theme.palette.mode === "dark" ? "greyLight" : "grey"}
                                    key={idx}
                                    clickable
                                    fitted
                                    borderless
                                    size={32}
                                    palette="normal"
                                >
                                    {t(state)}
                                </ShLabel>
                            ))}
                        </Box>


                        {selectedWorkSpace.id !== -1 &&
                            <Box
                                sx={{
                                    height:"calc(100% - 122px)",
                                    mt:3,
                                    "@media screen and (max-width: 47.9375em)" : {
                                        px:3,
                                        height:"unset",
                                    },
                                }}
                            >
                                {pausedOrdersForProcessing?.data?.length > 0 && !showPausedOrdersForProcessing &&
                                    <ButtonBase
                                        onClick={() => {
                                            setShowPausedOrdersForProcessing(true);
                                        }}
                                        sx={{
                                            width:1,
                                            mb:3,
                                            display:"flex",
                                            alignItems:"center",
                                            gap:1.5,
                                            height:40,
                                            borderRadius:5,
                                            background:colors.orange[400],
                                            color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["white"],
                                            fontSize:14,
                                            fontWeight:"bold",
                                            fontFamily:"Roboto, sans-serif",
                                            lineHeight:"40px",
                                            pl:2,
                                            pr:0.5,
                                        }}
                                    >
                                        {t("paused_orders_ready_for_processing")}
                                        <Box
                                            sx={{
                                                minWidth:32,
                                                px:1.5,
                                                ml:"auto",
                                                height:32,
                                                borderRadius:4,
                                                background:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["white"],
                                                color:colors.txt["primary"],
                                                textAlign:"center",
                                                lineHeight:"32px",
                                                fontSize:17,
                                            }}
                                        >
                                            {pausedOrdersForProcessing?.data?.length}
                                        </Box>
                                    </ButtonBase>
                                }

                                {pausedOrdersForProcessing?.data?.length > 0 && showPausedOrdersForProcessing &&
                                    <Box>
                                        <Box
                                            sx={{
                                                display:"flex",
                                                justifyContent:"space-between",
                                                alignItems:"center",
                                            }}
                                        >
                                            <Text bold variant="orange">{t("paused_orders_ready_for_processing")}</Text>

                                            <ButtonBase
                                                onClick={() => {
                                                    setShowPausedOrdersForProcessing(false);
                                                }}
                                                sx={{
                                                    width:1,
                                                    display:"flex",
                                                    alignItems:"center",
                                                    gap:1.5,
                                                    borderRadius:5,
                                                    // background:colors.orange[400],
                                                    color:colors.txt["primary"],
                                                    fontSize:14,
                                                    fontWeight:"bold",
                                                    fontFamily:"Roboto, sans-serif",
                                                    flex:0,
                                                    px:1,
                                                    height:32,
                                                }}
                                            >
                                                {t("close")}
                                            </ButtonBase>
                                        </Box>
                                        <Box
                                            sx={{
                                                display:"flex",
                                                flexDirection:"column",
                                                gap:1.5,
                                                mb:3,
                                                mt:1,
                                            }}
                                        >
                                            {pausedOrdersForProcessing?.data?.map((item) => (
                                                <SHQuickAction
                                                    key={"item"+item.id}
                                                    anchorOrigin={{
                                                        vertical:'center',
                                                        horizontal:"right"
                                                    }}
                                                    transformOrigin={{
                                                        vertical:'center',
                                                        horizontal:"left"
                                                    }}
                                                    component={
                                                        <Box
                                                            sx={{
                                                                minWidth:400,
                                                                width:1,
                                                                display:"flex",
                                                                flexDirection:"column",
                                                                justifyContent:"flex-start",
                                                                alignItems:"flex-start",
                                                            }}
                                                        >
                                                            <Text bold>{item.barcode}</Text>
                                                            <Text>{item.relation?.name}</Text>
                                                            <Text light>{item.deliveryName}</Text>
                                                        </Box>
                                                    }
                                                >
                                                    {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                                                        <ButtonBase
                                                            aria-owns={anchorEl ? 'simple-popover' : undefined}
                                                            // aria-haspopup={null}
                                                            // onMouseEnter={ false }
                                                            // onMouseLeave={false }
                                                            // onTouchStart={false }

                                                            key={"item"+item.id}
                                                            onClick={() => {
                                                                setOrderToFinalize({
                                                                    id:item.id,
                                                                    state:item.state,
                                                                });
                                                                // getPickingJob(item.id);
                                                            }}

                                                            sx={{
                                                                maxWidth:355,
                                                                display:'flex',
                                                                flexDirection:"column",
                                                                justifyContent:"flex-start",
                                                                alignItems:"flex-start",
                                                                boxShadow:"0px 2px 4px rgba(49,65,95,.15)",
                                                                border:`1px solid ${colors.grey[100]}`,
                                                                p:2,
                                                                borderRadius:4,
                                                                background: theme.palette.mode === 'dark' ? colors.grey[300] : colors.grey[0],
                                                                position:"relative",
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    display:'flex',
                                                                    justifyContent:"space-between",
                                                                    alignItems:"flex-start",
                                                                    width:1,

                                                                }}
                                                            >
                                                                <Box
                                                                    sx={{
                                                                        display:'flex',
                                                                        justifyContent:"space-between",
                                                                        flexDirection:"column",

                                                                    }}
                                                                >
                                                                    <Text bold>
                                                                        {item.barcode}
                                                                    </Text>
                                                                    <Text light>{item.deliveryName}</Text>

                                                                    <Box
                                                                        sx={{
                                                                            display:'flex',
                                                                            justifyContent:"space-between",
                                                                            mt:2,
                                                                            gap:1
                                                                            // flexDirection:"column",
                                                                        }}
                                                                    >
                                                                        <Text>{item.relation?.name}</Text>
                                                                        <Text light>{item.webshopreference}</Text>
                                                                    </Box>
                                                                </Box>
                                                                <TopRight>
                                                                    <CardLabel
                                                                        palette="normal"
                                                                        clickable
                                                                        fitted
                                                                        size={32}
                                                                        variant="orange"
                                                                        borderless
                                                                        sx={{
                                                                            whiteSpace:"nowrap",
                                                                            wordBreak:"keep-all",
                                                                        }}
                                                                    >
                                                                        {t("ready_for_processing")}

                                                                    </CardLabel>
                                                                </TopRight>
                                                                
                                                            </Box>
                                                            
                                                            <Box
                                                                sx={{
                                                                    width:1,
                                                                    mt:3,
                                                                    minHeight:32,
                                                                    borderRadius:4,
                                                                    background:colors.grey[100],
                                                                    px:3,
                                                                    py:1,
                                                                }}
                                                            >
                                                                <Text align="center" bold >{item.skipReason}</Text>
                                                            </Box>

                                                        </ButtonBase>   
                                                    )}
                                                </SHQuickAction>
                                                
                                            ))}
                                        </Box>
                                    </Box>
                                }

                                {!stateVisibility.completed ?
                                    groupedData && groupedData.groups && sortedStates.map((state) => (
                                        <Box key={state}
                                            sx={{
                                                display: stateVisibility[state] ? 'block' : 'none', // Hide/show based on visibility
                                            }}
                                        >
                                            <Text bold variant={getPickingJobStateData(state,theme).labelcolor}>{t(state)}</Text>
                                            {/* <ul> */}
                                            <Box
                                                sx={{
                                                    display:"flex",
                                                    flexDirection:"column",
                                                    gap:1.5,
                                                    mb:3,
                                                    mt:1,
                                                }}
                                            >
                                                {groupedData.groups[state].map((item) => (
                                                    <ButtonBase
                                                        disabled={invididualJobLoading}
                                                        key={"item"+item.id}
                                                        onClick={() => {
                                                            getPickingJob(item.id);
                                                        }}

                                                        sx={{
                                                            display:'flex',
                                                            flexDirection:"column",
                                                            boxShadow:"0px 2px 4px rgba(49,65,95,.15)",
                                                            border:`1px solid ${colors.grey[100]}`,
                                                            p:2,
                                                            borderRadius:4,
                                                            background: theme.palette.mode === 'dark' ? colors.grey[300] : colors.grey[0]
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                display:'flex',
                                                                justifyContent:"space-between",
                                                                alignItems:"center",
                                                                width:1,

                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    display:'flex',
                                                                    flexDirection:'column',
                                                                    // justifyContent:"flex-start",

                                                                }}
                                                            >
                                                                <Text semibold>
                                                                    {item.barcode}
                                                                </Text>
                                                                <Box
                                                                    sx={{
                                                                        mt:0.5,
                                                                        display:'flex',
                                                                        // justifyContent:"space-between",

                                                                    }}
                                                                >
                                                                    <Text light>{t("orders")}</Text> &nbsp;
                                                                    <Text bold>{item.orderCount}</Text>
                                                                </Box>
                                                            </Box>
                                                            
                                                            <Box
                                                                sx={{
                                                                    display:'flex',
                                                                }}
                                                            >
                                                                <ShLabel
                                                                    key={theme.palette.mode}
                                                                    variant={getPickingJobStateData(state,theme).labelcolor}
                                                                 
                                                                    fitted
                                                                    // borderless={!stateVisibility[state]}
                                                                    size={32}
                                                                    palette="normal"
                                                                    borderless
                                                                    sx={{
                                                                        flexShrink:0,
                                                                    }}
                                                                >
                                                                    {t(state)}
                                                                </ShLabel>
                                                                {((state === general_states.IN_PROGRESS || state === general_states.FULLYPICKED) && hasBulkPermission) &&
                                                                    <>
                                                                        <ButtonBase
                                                                            onClick={(event) => {
                                                                                event.stopPropagation();
                                                                                setItem(item);
                                                                                if(state === general_states.IN_PROGRESS){
                                                                                    handleAmStreamInProgressPopoverClick(event);
                                                                                } else {
                                                                                    handleAmStreamPickedPopoverClick(event);
                                                                                } 
                                                                            }}
                                                                            sx={{
                                                                                height:32,
                                                                                width:32,
                                                                                flexShrink:0,
                                                                                display:'flex',
                                                                                alignItems:'center',
                                                                                justifyContent:"center",
                                                                                borderRadius:4,
                                                                                ml:1,
                                                                                "&:hover" : {
                                                                                    background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100]
                                                                                }
                                                                            }}
                                                                        >
                                                                            <MoreVertIcon/>
                                                                        </ButtonBase>
                                                                    </>
                                                                }
                                                            </Box>
                                                        </Box>

                                                        <Box 
                                                            sx={{ 
                                                                width:1,
                                                                display:"flex",
                                                                justifyContent:"flex-start",
                                                                alignItems:"center",
                                                                mt: 3,
                                                                height:32,
                                                                background:theme.palette.mode === "dark" ? colors.grey[400]: colors.grey[100],
                                                                borderRadius:4,
                                                                pl:0.5,
                                                                gap:2,
                                                                color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["primary"],
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    height:24,
                                                                    background:theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[400],
                                                                    color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["white"],
                                                                    px:1,
                                                                    lineHeight:"24px",
                                                                    borderRadius:3,
                                                                    fontWeight:"bold",
                                                                    minWidth:80,
                                                                }}
                                                            >
                                                                {t("picked")}
                                                            </Box>
                                                            
                                                            {item?.userName ?? t("unknown")}
                                                            {/* <Typography variant="body1"><strong>{key}:</strong> {value}</Typography> */}
                                                        </Box>
                                                        {item.filters !== null ?
                                                            Object.entries(item.filters).map(([key, value],index) => (
                                                                <Box 
                                                                    key={key}
                                                                    sx={{ 
                                                                        width:1,
                                                                        display:"flex",
                                                                        justifyContent:"flex-start",
                                                                        alignItems:"center",
                                                                        mt: 1,
                                                                        height:32,
                                                                        background:theme.palette.mode === "dark" ? colors.grey[400]: colors.grey[100],
                                                                        borderRadius:4,
                                                                        pl:0.5,
                                                                        gap:2,
                                                                        color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["primary"],
                                                                    }}
                                                                >
                                                                    <Box
                                                                        sx={{
                                                                            height:24,
                                                                            background:theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[400],
                                                                            color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["white"],
                                                                            px:1,
                                                                            lineHeight:"24px",
                                                                            borderRadius:3,
                                                                            fontWeight:"bold",
                                                                            minWidth:80,
                                                                        }}
                                                                    >
                                                                        {t(key)}
                                                                    </Box>
                                                                    
                                                                    {value}
                                                                    {/* <Typography variant="body1"><strong>{key}:</strong> {value}</Typography> */}
                                                                </Box>
                                                            ))
                                                        :null}


                                                    </ButtonBase>
                                                ))}
                                            </Box>
                                            {/* </ul> */}
                                        </Box>
                                    ))
                                    :
                                    
                                    <Box
                                        sx={{
                                            display:"flex",
                                            flexDirection:"column",
                                            gap:1.5,
                                            mb:3,
                                            mt:1,
                                        }}
                                    >
                                        {completedJobs.map(item => (
                                            <ButtonBase
                                                disabled={invididualJobLoading}
                                                key={"item"+item.id}
                                                onClick={() => {
                                                    getPickingJob(item.id);
                                                }}

                                                sx={{
                                                    display:'flex',
                                                    flexDirection:"column",
                                                    boxShadow:"0px 2px 4px rgba(49,65,95,.15)",
                                                    border:`1px solid ${colors.grey[100]}`,
                                                    p:2,
                                                    borderRadius:4,
                                                    background: theme.palette.mode === 'dark' ? colors.grey[300] : colors.grey[0]
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display:'flex',
                                                        justifyContent:"space-between",
                                                        alignItems:"center",
                                                        width:1,

                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            display:'flex',
                                                            flexDirection:'column',
                                                            // justifyContent:"flex-start",

                                                        }}
                                                    >
                                                        <Text semibold>
                                                            {item.barcode}
                                                        </Text>
                                                        <Box
                                                            sx={{
                                                                mt:0.5,
                                                                display:'flex',
                                                                // justifyContent:"space-between",

                                                            }}
                                                        >
                                                            <Text light>{t("orders")}</Text> &nbsp;
                                                            <Text bold>{item.orderCount}</Text>
                                                        </Box>
                                                    </Box>
                                                    
                                                    <Box
                                                        sx={{
                                                            display:'flex',
                                                        }}
                                                    >
                                                        <ShLabel
                                                            key={theme.palette.mode}
                                                            variant={getPickingJobStateData(general_states.COMPLETED,theme).labelcolor}
                                                            
                                                            fitted
                                                            // borderless={!stateVisibility[state]}
                                                            size={32}
                                                            palette="normal"
                                                            borderless
                                                            sx={{
                                                                flexShrink:0,
                                                            }}
                                                        >
                                                            {t(general_states.COMPLETED)}
                                                        </ShLabel>
                                                        {(hasBulkPermission) &&
                                                            <>
                                                                <ButtonBase
                                                                    onClick={(event) => {
                                                                        event.stopPropagation();
                                                                        setItem(item);
                                                                        handleAmStreamFinishedPopoverClick(event);
                                                                    }}
                                                                    sx={{
                                                                        height:32,
                                                                        width:32,
                                                                        flexShrink:0,
                                                                        display:'flex',
                                                                        alignItems:'center',
                                                                        justifyContent:"center",
                                                                        borderRadius:4,
                                                                        ml:1,
                                                                        "&:hover" : {
                                                                            background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100]
                                                                        }
                                                                    }}
                                                                >
                                                                    <MoreVertIcon/>
                                                                </ButtonBase>
                                                            </>
                                                        }
                                                    </Box>
                                                </Box>

                                                <Box 
                                                    sx={{ 
                                                        width:1,
                                                        display:"flex",
                                                        justifyContent:"flex-start",
                                                        alignItems:"center",
                                                        mt: 3,
                                                        height:32,
                                                        background:theme.palette.mode === "dark" ? colors.grey[400]: colors.grey[100],
                                                        borderRadius:4,
                                                        pl:0.5,
                                                        gap:2,
                                                        color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["primary"],
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            height:24,
                                                            background:theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[400],
                                                            color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["white"],
                                                            px:1,
                                                            lineHeight:"24px",
                                                            borderRadius:3,
                                                            fontWeight:"bold",
                                                            minWidth:80,
                                                        }}
                                                    >
                                                        {t("picked")}
                                                    </Box>
                                                    
                                                    {item?.userName ?? t("unknown")}
                                                    {/* <Typography variant="body1"><strong>{key}:</strong> {value}</Typography> */}
                                                </Box>
                                                {item.filters !== null ?
                                                    Object.entries(item.filters).map(([key, value],index) => (
                                                        <Box 
                                                            key={key}
                                                            sx={{ 
                                                                width:1,
                                                                display:"flex",
                                                                justifyContent:"flex-start",
                                                                alignItems:"center",
                                                                mt: 1,
                                                                height:32,
                                                                background:theme.palette.mode === "dark" ? colors.grey[400]: colors.grey[100],
                                                                borderRadius:4,
                                                                pl:0.5,
                                                                gap:2,
                                                                color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["primary"],
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    height:24,
                                                                    background:theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[400],
                                                                    color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["white"],
                                                                    px:1,
                                                                    lineHeight:"24px",
                                                                    borderRadius:3,
                                                                    fontWeight:"bold",
                                                                    minWidth:80,
                                                                }}
                                                            >
                                                                {t(key)}
                                                            </Box>
                                                            
                                                            {value}
                                                            {/* <Typography variant="body1"><strong>{key}:</strong> {value}</Typography> */}
                                                        </Box>
                                                    ))
                                                :null}


                                            </ButtonBase>
                                        ))}
                                        {/* {console.log(jobsData)} */}
                                        {page < jobsData?.totalPages &&
                                            <div ref={ref} >
                                                {jobsFetching && <p>Loading more...</p>}
                                            </div>
                                        }
                                    </Box>

                                }
                            </Box>
                        }

                        {selectedWorkSpace.id === -1 &&
                            <SelectWorkSpace/>
                        }
                    </Box>

                    <Box
                        sx={{
                            flex: 1,
                            background: theme.palette.mode === "dark" ? colors.grey[300] : colors.bg["tertiary"],
                            borderTopRightRadius: 16,
                            borderTopLeftRadius: 16,
                            overflow: "hidden",
                            display: "inline-flex",
                            flexDirection: "column",
                            justifyContent: 'center',  // To center contents vertically
                            alignItems: 'center',      // To center contents horizontally
                            "@media screen and (max-width: 47.9375em)" : {
                                width:1,
                                overflow:"hidden",
                                flexDirection:"row",
                                position:'fixed',
                                height:72,
                                bottom:0,
                                left:0,
                                right:0,
                                pb:0,
                                px:3,
                                gap:0,
                                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                boxShadow:`0px 0px 19px ${colors.grey[200]}`,
                                border:`1px solid ${colors.grey[100]}`,
                                display:selectedWorkSpace.id !== -1 ? "flex": "none",
                            }
                        }}
                    >
                        <Box
                            sx={{
                                flex:1,
                                // height:400,
                                flexShrink:0,
                                display: "inline-flex",
                                flexDirection: "column",
                                justifyContent: 'center',  // To center contents vertically
                                alignItems: 'center',      // To center contents horizontally
                                 gap: 2,
                            }}
                        >
                            <Box
                                sx={{
                                    height:210,
                                    width:440,
                                    borderRadius:5,
                                    position:"relative",
                                    display:"flex",
                                    alignItems:"center",
                                    justifyContent:"center",
                                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[200],
                                    border:`1px solid ${theme.palette.mode === "dark" ? colors.grey[100] : colors.grey[300]}`,
                                    "& .echeck-barcode-svg" : {
                                        height:150,
                                        width:"380px !important",
                                        animation: 'pulsate 2s infinite',
                                        "& path" : {
                                            fill: theme.palette.mode === "dark" ? colors.txt["secondary"] : "#8E96A7"
                                        }
                                    },
                                    "@media screen and (max-width: 47.9375em)" : {
                                        width:66,
                                        pl:2,
                                        height:40,
                                        flexShrink:0,
                                        borderTopRightRadius:0,
                                        borderBottomRightRadius:0,
                                        background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[100],
                                        border:"none",
                                        "& .echeck-barcode-svg" : {
                                            width:"75% !important",
                                        },
                                    }
                                }}
                            >

                                <BarcodeSvg 
                                    className="echeck-barcode-svg"
                                />
                            </Box>
                            
                            {selectedWorkSpace?.id !== -1 &&
                                <>
                                    <InputBase 
                                        // ref={inputRef}
                                        inputRef={inputRef}
                                        sx={{
                                            // mt:1,
                                            height:40,
                                            background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[200],
                                            borderRadius:5,
                                            color:colors.txt["primary"],
                                            fontWeight:500,
                                            fontFamily:"Roboto, sans-serif",
                                            width: 248, 
                                            maxWidth:440,
                                            width:1,
                                            px:2,
                                            '& input': {
                                                textAlign: 'center', 
                                            },
                                            "@media screen and (max-width: 47.9375em)" : {
                                                width:1,
                                                // borderBottomLeftRadius:0,
                                                // borderTopLeftRadius:0,
                                                background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[100],
                                            }
                                        }} 
                                        placeholder={t("scan_type_barcode")}
                                        onKeyDown={handleGetPickingJobOrOrderToEcheck}
                                        autoFocus={window.innerWidth > 767}
                                    />
                                    <Shbutton 
                                        modalFooterBtn
                                        // className={"group-btn"} 
                                        color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"} 
                                        onClick={() => handleCreateExtendedBatchOpen(true)}
                                        endIcon={<AddIcon/>}
                                        variant="contained"
                                        sx={{
                                            pl:7,
                                            width: 248, 
                                            maxWidth:440,
                                            width:1,
                                            justifyContent:"space-between"
                                        }}
                                    >
                                        {t('create_batch')}
                                    </Shbutton>
                                </>
                            }
                        </Box>

                        <AllConceptJobs
                            setHighlightColor={setHighlightColor}
                        />



                        <AMStreamInProrgess 
                            id={amStreamInProgressPopoverId}
                            open={amStreamInProgressPopoverOpen}
                            anchorEl={amStreamInProgressAnchorEl}
                            onClose={handleAmStreamInProgressPopoverClose}
                            setHighlightColor={setHighlightColor}
                                
                            item={item}
                            refetchJobs={refetchJobs}
                            activateStreamPanel={activateStreamPanel}
                        />


                        <AMStreamPicked
                            id={amStreamPickedPopoverId}
                            open={amStreamPickedPopoverOpen}
                            anchorEl={amStreamPickedAnchorEl}
                            onClose={handleAmStreamPickedPopoverClose}
                            setHighlightColor={setHighlightColor}
                                
                            item={item}
                            refetchJobs={refetchJobs}
                            activateStreamPanel={activateStreamPanel}
                        />

                        <AMStreamFinished
                            id={amStreamFinishedPopoverId}
                            open={amStreamFinishedPopoverOpen}
                            anchorEl={amStreamFinishedAnchorEl}
                            onClose={handleAmStreamFinishedPopoverClose}
                            setHighlightColor={setHighlightColor}
                            activateStreamPanel={activateStreamPanel}
                        />

                        <MCreateBatch
                            onOpen={() => createExtendedBatchModal.setOpen(true)} 
                            onClose={() => createExtendedBatchModal.setOpen(false)} 
                            open={createExtendedBatchModal.open} 
                            handleClose={handleCreateExtendedBatchClose} 
                        />
                        {/* UNCOMMENT WHEN BACKEND FOR STANDALONE SHIPMENTS HAS BEEN MADE */}
                        {/* {( selectedWorkSpace?.id > 0 && canCreateStandAloneShipment) &&
                            <ButtonBase
                                onClick={() => {createShipmentModal.setOpen(true)}}
                                sx={{
                                    mt:3,
                                    height:40,
                                    borderRadius:5,
                                    background:theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[400],
                                    maxWidth:440,
                                    width:1,
                                    color: theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                                    fontSize:14,
                                    fontWeight:"bold",
                                }}
                            >
                                {t("create_standalone_shipment")}
                            </ButtonBase>
                        } */}
                    </Box>
                </Box>
            }

            {showEcheck ?
                <>
                    {incData.viewType === "products" ?
                        <EcheckContentWrapper
                            open={showEcheck}
                            setOpen={(open) => { if (!open) setShowEcheck(false); }}
                            incData={incData}
                            setIncData={setIncData}
                            setHighlightColor={setHighlightColor}
                            refetchJobs={refetchJobs}
                            selectedWorkSpace={selectedWorkSpace}
                        >
                            <OrdersEcheckView2
                                displayPopupForOutboundInstructions={displayPopupForOutboundInstructions}
                                displayPopupForB2bOrder={displayPopupForB2bOrder}
                                onB2bOrderOpened={() => setB2bWarningOpen(true)}
                                confirmProductAmount={confirmProductAmountSetting}
                                skipProductAmountCheck={canSkipAmountCheck}
                                hasAllowedToSetCustomCarrierShipperPermission={hasAllowedToSetCustomCarrierShipperPermission}
                                playError={playError}
                                playSuccess={playSuccess}
                                invoiceProductsEcheck={invoiceProductsEcheck}
                                firstScannedBarcode={scannedValue}
                                setHighlightColor={setHighlightColor}
                                incData={incData}
                                autoFinalize={autoFinalize}
                                carrierMandatory={carrierMandatory}
                                canFinalizeWithoutLabel={canFinalizeWithoutLabel}
                                selectedWorkSpace={selectedWorkSpace}
                                goBack={goBack}
                                setIncData={setIncData}
                                setShowEcheck={setShowEcheck}
                                jobsLoading={jobsLoading}
                                jobsFetching={jobsFetching}
                                refetchJobs={refetchJobs}
                                finalizeAutoOnTimer={finalizeAutoOnTimer}
                                hasClickToScanPermission={hasClickToScanPermission}
                                finalizeTimer={finalizeTimer ?? 5000}
                                finalizeOnEnter={finalizeOnEnter}
                                firstProductClick={firstProductClick}
                                viewStocksInOrderProcessing={viewStocksInOrderProcessing}
                                viewPickingLinesInOrderProcessing={viewPickingLinesInOrderProcessing}
                                clickAllProducts={clickAllProducts}
                                openSinglesModalOnScan={openSinglesModalOnScan}
                            />
                        </EcheckContentWrapper>
                    :
                        <EcheckContentWrapper
                            open={showEcheck}
                            setOpen={(open) => { if (!open) setShowEcheck(false); }}
                            incData={incData}
                            setIncData={setIncData}
                            setHighlightColor={setHighlightColor}
                            refetchJobs={refetchJobs}
                            selectedWorkSpace={selectedWorkSpace}
                        >
                            <LocationsEcheckView
                                displayPopupForOutboundInstructions={displayPopupForOutboundInstructions}
                                displayPopupForB2bOrder={displayPopupForB2bOrder}
                                onB2bOrderOpened={() => setB2bWarningOpen(true)}
                                confirmProductAmount={confirmProductAmountSetting}
                                skipProductAmountCheck={canSkipAmountCheck}
                                hasAllowedToSetCustomCarrierShipperPermission={hasAllowedToSetCustomCarrierShipperPermission}
                                playError={playError}
                                playSuccess={playSuccess}
                                invoiceProductsEcheck={invoiceProductsEcheck}
                                firstScannedBarcode={scannedValue}
                                setHighlightColor={setHighlightColor}
                                incData={incData}
                                autoFinalize={autoFinalize}
                                carrierMandatory={carrierMandatory}
                                canFinalizeWithoutLabel={canFinalizeWithoutLabel}
                                selectedWorkSpace={selectedWorkSpace}
                                goBack={goBack}
                                setIncData={setIncData}
                                setShowEcheck={setShowEcheck}
                                jobsLoading={jobsLoading}
                                jobsFetching={jobsFetching}
                                refetchJobs={refetchJobs}
                                finalizeAutoOnTimer={finalizeAutoOnTimer}
                                hasClickToScanPermission={hasClickToScanPermission}
                                finalizeTimer={finalizeTimer ?? 5000}
                                finalizeOnEnter={finalizeOnEnter}
                                viewStocksInOrderProcessing={viewStocksInOrderProcessing}
                                viewPickingLinesInOrderProcessing={viewPickingLinesInOrderProcessing}
                                clickAllProducts={clickAllProducts}
                            />
                        </EcheckContentWrapper>
                    }
                </>
                :
                orderToFinalize && eCheckSettings &&
                <>
                    <EcheckContentWrapper
                        open={!!orderToFinalize}
                        setOpen={(open) => { if (!open) { setOrderToFinalize(null); setShowEcheck(false); setIncData(null); } }}
                        incData={incData}
                        setIncData={setIncData}
                        setHighlightColor={setHighlightColor}
                        refetchJobs={refetchJobs}
                        selectedWorkSpace={selectedWorkSpace}
                    >
                        <IndividualOrderEcheckView
                            displayPopupForOutboundInstructions={displayPopupForOutboundInstructions}
                            displayPopupForB2bOrder={displayPopupForB2bOrder}
                            onB2bOrderOpened={() => setB2bWarningOpen(true)}
                            confirmProductAmount={confirmProductAmountSetting}
                            skipProductAmountCheck={canSkipAmountCheck}
                            hasAllowedToSetCustomCarrierShipperPermission={hasAllowedToSetCustomCarrierShipperPermission}
                            playError={playError}
                            playSuccess={playSuccess}
                            invoiceProductsEcheck={invoiceProductsEcheck}
                            orderToFinalize={orderToFinalize}
                            incData={incData}
                            setHighlightColor={setHighlightColor}
                            autoFinalize={autoFinalize}
                            carrierMandatory={carrierMandatory}
                            canFinalizeWithoutLabel={canFinalizeWithoutLabel}
                            selectedWorkSpace={selectedWorkSpace}
                            goBack={goBack}
                            setOrderToFinalize={setOrderToFinalize}
                            setShowEcheck={setShowEcheck}
                            jobsLoading={jobsLoading}
                            jobsFetching={jobsFetching}
                            finalizeAutoOnTimer={finalizeAutoOnTimer}
                            hasClickToScanPermission={hasClickToScanPermission}
                            finalizeTimer={finalizeTimer ?? 5000}
                            finalizeOnEnter={finalizeOnEnter}
                            viewStocksInOrderProcessing={viewStocksInOrderProcessing}
                            viewPickingLinesInOrderProcessing={viewPickingLinesInOrderProcessing}
                            clickAllProducts={clickAllProducts}
                        />
                    </EcheckContentWrapper>
                </>
            }

            {spLoading && 
                <SpPickingJobPickingList
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    pickingJobListId={item?.id}
                    defaultTab={spOrderSidePanelTab}
                    // data={streamData} 
                /> 
            }

            <MSelectWorkspaces
                open={workSpaceModal.open} 
                handleClose={() => workSpaceModal.setOpen(false)}
            />
            <MpCreateStandaloneShipment
                open={createShipmentModal.open}
                handleClose={() => {
                    createShipmentModal.setOpen(false);
                    setTimeout(() => {
                        inputRef.current.focus();
                    },100);
                }}
            />

            <MConfirmation
                open={b2bWarningOpen}
                handleClose={() => setB2bWarningOpen(false)}
                confirm={() => setB2bWarningOpen(false)}
                title={t("b2b_order")}
                content={t("b2b_order_warning")}
            />
        </Box>
    );
};

export default Echeck;

const SelectWorkSpace = (props) => {
    const { t, ready } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const selectedWorkSpace = useSelector((state) => state.settings.workSpace);
    const [selected, setSelected] = useState(-1);
    const [workTSpace,setTWorkSpace] = useState(selectedWorkSpace);

    const select = (selected) => {
        setTWorkSpace(data[selected]);
    }
    const { data: workSpaceData, isLoading } = useFindWorkspacesSelectQuery();

    useEffect(() => {
        if (!isLoading && workSpaceData) {
            const modifiedArray = workSpaceData.data.map(item => ({
                ...item,
                title: item.name
              }));
            
            setData(modifiedArray);
        }
    }, [workSpaceData, isLoading]);


    const selectWorkSpace = () => {
        dispatch(setWorkSpace({
            id:workTSpace.id,
            name:workTSpace.name,
        }));
    }

    useEffect(() => {
        if(data.length > 0) {
            for(var i = 0;i < data.length; i++) { 
                if(data[i].id === selectedWorkSpace.id){
                    setSelected(i);
                    // setSelected
                }
            }
        }
    }, [selectedWorkSpace,data]);


    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    return(
        <Box
            sx={{
                mt:3,
                py:3,
                background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[200],
                px:2,
                borderRadius:4,
                "@media screen and (max-width: 47.9375em)" : {
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    mt:0,
                    pt:0,
                }
            }}
        >
            
            <Box 
                sx={{
                    textAlign:"center",
                    // paddingY:4,
                    // paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}>
                <Subheading>{props.subheading || t("select_workspace")}</Subheading>
            </Box>
            <Box
                sx={{
                    pt:3,
                }}
            >
                <SelectGroup selected={selected} setSelected={select} options={data} />
            </Box>
            
            <Box
                sx={{
                    paddingTop:3,
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton block className={"group-btn"} color={theme.palette.mode === "dark" ? "blue" : "primary"} onClick={() => selectWorkSpace()} variant="contained">{t('select')}</Shbutton>
            </Box>
        </Box>
    )
}

const gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
};


const AllConceptJobs = (props) => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const dispatch = useDispatch();
    const [jobId,setJobId] = useState(null);
    const [isEmpty, setIsEmpty] = useState(true);



    const [mEditBatcHOpen, setMEditBatcHOpen] = useState(false);
    const [confirmEndStreamModalOpen, setConfirmEndStreamModalOpen] = useState(false);
    const confirmEndStreamModal = {
        open: confirmEndStreamModalOpen,
        setOpen: setConfirmEndStreamModalOpen,
    };

    const handleConfirmEndStreamClose = () => {
        confirmEndStreamModal.setOpen(false);
    };

    const [endPickingJob, {isLoading: endPickingJobLoading}] = useFinishPickingJobMutation();
    const handleEndStream = async (setPickedToOpen) => {
        if(!jobId) return;
        if(endPickingJobLoading) return;

        await endPickingJob({ pickingJobId: jobId, setPickedToOpen })
        .unwrap()
        .then(res => {
            props.setHighlightColor('green');
            setJobId(null);
        })
        .catch(error => {
            props.setHighlightColor('red');
            toast.error(error.data?.message ??  `Er is iets misgegaan`, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        });
    }
    

    const columns = [
        {
            field: "barcode", 
            headerName: t('barcode'),
            flex:1, 
            renderCell : (params) => {
                if (params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return params.row.barcode;
            }
        },
        {
            field: "user", 
            headerName: t('user'),
            flex:2, 
            renderCell : (params) => {
                if (params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return params.row.userName;
            }
        },
        {
            field: "orderCount", 
            headerName: t('orderCount'),
            flex:2, 
            renderCell : (params) => {
                if (params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return params.row.orderCount;
            }
        },
        {
            field: "total_products", 
            headerName: t('total_products'),
            flex:2, 
            renderCell : (params) => {
                if (params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return params.row.total_products;
            }
        },
        {
            field: "warehouse", 
            headerName: t('warehouse'),
            flex:4, 
            renderCell : (params) => {
                if (params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return (
                    <Box
                        sx={{
                            width:1,
                            display:"flex",
                            alignItems:'center',
                            gap:2,
                        }}
                    >
                        <Text>{params.row.warehouse?.name}</Text>
                        <Box
                            sx={{
                                ml:"auto",
                                display:"flex",
                                alignItems:'center',
                            }}
                        >
                            <ButtonBase
                                onClick={async () => {
                                    setJobId(params.row.id);
                                    setMEditBatcHOpen(true);
                                }}
                                sx={{
                                    ml:1,
                                    px:1.5,
                                    // width:32,
                                    height:32,
                                    borderRadius:4,
                                    background:theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                    color: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                                    textAlign:'center',
                                    justifyContent:'center',
                                    fontWeight:500,
                                    fontSize:14,
                                    fontFamily:"Roboto, sans-serif",
                                    "&:hover" : {
                                        background:theme.palette.mode === "dark" ? colors.blue[200] : colors.primary[200],
                                    }
                                }}
                            >
                                {t("continue")}
                            </ButtonBase>

                            <ButtonBase
                                onClick={async () => {
                                    confirmEndStreamModal.setOpen(true);
                                    setJobId(params.row.id);
                                }}
                                sx={{
                                    ml:1,
                                    width:32,
                                    height:32,
                                    borderRadius:4,
                                    color:colors.red[400],
                                    textAlign:'center',
                                    justifyContent:'center',
                                    "&:hover" : {
                                        background:colors.red[100]
                                    }
                                }}
                            >
                                <NotInterestedOutlinedIcon/>
                            </ButtonBase>

                        </Box>
                    </Box>
                );
            }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (cellValues) => {
                if(cellValues.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return <ShTextSkeleton/>
                // return (
                //     <RelationWebshopIntegrationCard skeleton={cellValues.row.skeleton ?? false} {...cellValues.row}/>
                //     // <WarehouseAccountingSoftwareCard onClick={() => getAccountingSoftwareDetails(cellValues)} skeleton={cellValues.row.skeleton ?? false} {...cellValues.row}/>
                // )
            }
        }
    ];

    return (
        <Box display={isEmpty === true ? "none" : "flex"} flexDirection={"column"}
            sx={{
                flex:1,
                width:"calc(100% - 64px)",
                background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                position:"relative",
                zIndex:2,

                flexDirection:"column",

                "&:before" : {
                    content: "''",
                    display:"block",
                    width:"32px",
                    height:"32px",
                    position:"absolute",
                    left:0,
                    top:0,
                    zIndex:1,
                    backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    top:"0px",
                    height:"48px",
                    width:"24px",
                    borderTopLeftRadius:"24px",
                    boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                    // transition:"250ms"
                },

                "&:after" : {
                    content: "''",
                    display:"block",
                    width:"32px",
                    height:"32px",
                    position:"absolute",
                    top:40,
                    zIndex:1,
                    backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    top:"0px",
                    right:0,
                    height:"48px",
                    width:"24px",
                    borderTopLeftRadius:"24px",
                    boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                    transform:"scaleX(-1)",
                    // transition:"250ms"
                },

                "@media screen and (max-width: 47.9375em)" : {
                    "&:after, &:before" : {
                        top:"-0px"
                    }
                }
            }}
        >
            <TabContextProvider>
                <GridFilterProvider activeChild={"chart"}>
                    <ShDataGrid2 key={theme.palette.mode}
                        content={useFindAllConceptJobsQuery}
                        // gridActions={<GridActions action={handleSync} isLoading={isLoading} type={props.accountingSoftwareType}></GridActions>}
                        title={t('concept_jobs')}
                        gridOptions={gridOptions}
                        isSidepanelGrid
                        columns={columns}
                        onEmpty={setIsEmpty}
                        paginationSx={{
                            position:"absolute !important",
                            left:"50% !important",
                            right:"unset !important",
                            transform:"translateX(-50%) !important",
                            // bottom:120,
                        }}
                    />
                </GridFilterProvider>
            </TabContextProvider>

            <MConfirmEndPickingJob
                open={confirmEndStreamModal.open}
                handleClose={handleConfirmEndStreamClose}
                title={t("stop_pickingjob_title")}
                subtitle={t("stop_pickingjob_subtitle")}
                confirm={(setPickedToOpen) => handleEndStream(setPickedToOpen)}
            />
            <MEditBatch
                id={jobId}
                open={mEditBatcHOpen}
                handleClose={() => setMEditBatcHOpen(false)}
            />
        </Box>
    )
}